import { ForwardedRef, forwardRef } from 'react';
import { Props } from '@components/textarea/src/textarea.types';
import { mergeTwClasses } from '@utils/merge-tw-classes';

export const Textarea = forwardRef(
  ({ hasError, readOnly, className, ...props }: Props, ref: ForwardedRef<HTMLTextAreaElement>) => {
    const textAreaClasses = mergeTwClasses(
      'w-full border p-3.5 rounded-md text-primary text-body-m focus:outline-hidden placeholder-neutral-50 dark:placeholder-neutral-10',
      {
        'border-critical-soft focus:ring-transparent focus:ring-0 focus:border-critical-no-bg': hasError,
        'border-soft focus:ring-0 focus:border-medium': !hasError,
        'fill-primary': !readOnly,
        'cursor-not-allowed fill-primary-disabled': readOnly,
      },
      className
    );

    return <textarea className={textAreaClasses} readOnly={readOnly} {...props} ref={ref} />;
  }
);
